import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-scc-password',
  templateUrl: './scc-password.component.html',
  styleUrls: ['./scc-password.component.scss']
})
export class SccPasswordComponent {
  @Input() label = '';
  @Input() control: FormControl = new FormControl();

  hide = true;
}
